import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/utils/pwaUtils";

// CRITICAL: Fix ResizeObserver loop error for iOS Safari
// This MUST run before anything else
(function() {
  if (typeof window === 'undefined') return;
  
  // Suppress the error event before React can catch it
  const errorHandler = (event) => {
    if (event.message && event.message.includes('ResizeObserver loop')) {
      event.stopImmediatePropagation();
      event.stopPropagation();
      event.preventDefault();
      return true;
    }
  };
  
  window.addEventListener('error', errorHandler, true);
  
  // Patch ResizeObserver to use requestAnimationFrame
  const OriginalResizeObserver = window.ResizeObserver;
  if (OriginalResizeObserver) {
    window.ResizeObserver = function(callback) {
      const wrappedCallback = (entries, observer) => {
        window.requestAnimationFrame(() => {
          if (typeof callback === 'function') {
            callback(entries, observer);
          }
        });
      };
      return new OriginalResizeObserver(wrappedCallback);
    };
    
    // Copy static properties
    for (let prop in OriginalResizeObserver) {
      if (OriginalResizeObserver.hasOwnProperty(prop)) {
        window.ResizeObserver[prop] = OriginalResizeObserver[prop];
      }
    }
    window.ResizeObserver.prototype = OriginalResizeObserver.prototype;
  }
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register PWA Service Worker
registerServiceWorker();
